module.exports = __webpack_public_path__ + "img/icon.80bde518.png";